module.exports = __webpack_public_path__ + "static/dir-ca8c33faf6738220ba2d0415ce179923.png";